import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import GetSeodata from '../Components/GetSeodata'

function Lead() {
  return (
    <>
      <Navbar />
      <GetSeodata PageName={'lead'} />
      <div className='about-div'>
        <h1>Leads</h1>
        <p><i>Home - Leads</i></p>

      </div>
      <div className='table-div'>

        <table class="table table-striped">
          <thead>
            <tr className='table-heading'>
              <th scope="col">S.No.</th>
              <th scope="col">Name</th>
              <th scope="col">Address</th>
              <th scope="col">Contact</th>
              <th scope="col">Email</th>
              <th scope="col">Inquire</th>


            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Strix Digital</td>
              <td>Inodre,(M.P.)</td>
              <td>9874563210</td>
              <td>strixdigital@gmail.com</td>
              <td>Villa</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Strix Digital</td>
              <td>Inodre,(M.P.)</td>
              <td>9874563210</td>
              <td>strixdigital@gmail.com</td>
              <td>Villa</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Strix Digital</td>
              <td>Inodre,(M.P.)</td>
              <td>9874563210</td>
              <td>strixdigital@gmail.com</td>
              <td>Villa</td>
            </tr>
          </tbody>
        </table>
      </div>

      <Footer />
    </>
  )
}

export default Lead